import UploadImage from "@components/UploadImage";
import { useFullServiceDisplay } from "@hooks/useFullServiceDisplay";
import { Trans } from "react-i18next";

export default function FullServiceLarge() {
  const { isShowFullService } = useFullServiceDisplay();
  if (isShowFullService) {
    return (
      <div className="h-[24px] px-[4px] flex flex-row gap-[2px] bg-[#FF69B4] absolute left-0 top-0  text-white font-bold rounded-tl-[4px] rounded-br-[4px] items-center">
        <UploadImage className="w-[16px] h-[16px]" name="29a5cad7.png"></UploadImage>
        <div className="text-[12px] h-[17px]">
          <Trans>Full-Service Product</Trans>
        </div>
      </div>
    );
  }
  return null;
}
